import { PaletteMode, colors, createTheme } from "@mui/material";
import { amber, deepOrange, green, grey, orange } from "@mui/material/colors";
export const theme = createTheme({
  typography: {
    fontFamily: [
      '"Outfit"',
      '"Poppins"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  manna: {
    danger: orange[500],
    warning: "#EAAC30",
  },
  palette: {
    error: {
      main: "#ED0505",
    },
    other: {
      disabledBackground: "#667085",
      disabledText: "#D0D5DD",
    },
    primary: {
      main: "#FFFFFF",
    },
    secondary: {
      main: "#101828",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#101828",
    },
    background: {
      default: colors.green[500],
      paper: "#101828",
    },
  },
});

const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    ...(mode === "light"
      ? {
          // palette values for light mode
          primary: amber,
          divider: amber[200],
          text: {
            primary: grey[900],
            secondary: grey[800],
          },
        }
      : {
          // palette values for dark mode
          primary: deepOrange,
          divider: deepOrange[700],
          background: {
            default: deepOrange[900],
            paper: deepOrange[900],
          },
          text: {
            primary: "#fff",
            secondary: grey[500],
          },
        }),
  },
});

declare module "@mui/material/styles" {
  interface Theme {
    manna: {
      danger: string;
      warning: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    manna?: {
      danger?: string;
      warning?: string;
    };
  }
}

declare module "@mui/material/styles/createPalette" {
  interface Palette {
    other: {
      disabledBackground?: string;
      disabledText?: string;
    };
  }
  interface PaletteOptions {
    other: {
      disabledBackground?: string;
      disabledText?: string;
    };
  }
}

console.log(theme);
